<script>
  import { onMount } from "svelte";
  import { currentUser } from "../utils/utils.js";
  import WidgetCustomization from "./WidgetCustomization.svelte";
  import { NotificationDisplay } from "@shopboxai/sb-portal-components";
  export let currentClient = null;

  export let user;

  let mounted = false;
  onMount(() => {
    currentUser.set(user);
    mounted = true;
  });
</script>

{#if mounted}
  <div class="app-container">
    <h1>Widget Customization</h1>
    <WidgetCustomization />
    <NotificationDisplay />
  </div>
{/if}

<style>
  :global(*) {
    box-sizing: border-box;
    margin: 0;
  }
  :global(html, body) {
    width: 100%;
    height: 100%;
    font-family: "Overpass", sans-serif;
  }
  h1 {
    font-family: "Chivo", serif;
    margin-bottom: 1.5em;
  }
</style>
